import * as tslib_1 from "tslib";
import { BaseModel } from '../_base/model.class';
var Intervention = /** @class */ (function (_super) {
    tslib_1.__extends(Intervention, _super);
    function Intervention(_id, name, propertyName, type, status, totalFee, meetingResolutionDate, contractors, constructionManagement, securityCoordinator, constructionStart, constructionEnd, taxDeductionType, taxDeductionFees, notes, receivedDocuments, createdBy, createdAt, updatedBy, updatedAt) {
        var _this = _super.call(this) || this;
        _this._id = _id;
        _this.name = name;
        _this.propertyName = propertyName;
        _this.type = type;
        _this.status = status;
        _this.totalFee = totalFee;
        _this.meetingResolutionDate = meetingResolutionDate;
        _this.contractors = contractors;
        _this.constructionManagement = constructionManagement;
        _this.securityCoordinator = securityCoordinator;
        _this.constructionStart = constructionStart;
        _this.constructionEnd = constructionEnd;
        _this.taxDeductionType = taxDeductionType;
        _this.taxDeductionFees = taxDeductionFees;
        _this.notes = notes;
        _this.receivedDocuments = receivedDocuments;
        _this.createdBy = createdBy;
        _this.createdAt = createdAt;
        _this.updatedBy = updatedBy;
        _this.updatedAt = updatedAt;
        _this.setRequiredFields([
            '_id',
            'name',
            'createdAt',
            'createdBy',
        ]);
        return _this;
    }
    return Intervention;
}(BaseModel));
export { Intervention };
